"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
require("./tabs.css");
var Tabs = function (_a) {
    var items = _a.items, selected = _a.selected, _b = _a.theme, theme = _b === void 0 ? 'default' : _b;
    function renderTabs() {
        return items.map(function (item) { return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: "tab-item ".concat(item.slug === selected ? 'tab-item-selected' : '', " tab-item-").concat(theme), onClick: item.onClick }, { children: [(0, jsx_runtime_1.jsx)("span", { children: item.name }), item.slug === selected ? (0, jsx_runtime_1.jsx)("div", {}) : null] }), item.slug) }, item.slug)); });
    }
    return (0, jsx_runtime_1.jsx)("span", __assign({ className: "tabs-container" }, { children: renderTabs() }));
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map